import { useIntl } from "react-intl";

import { FlightButton } from "@/features/flights/components/flight-purchase/FlightButton";
import type { GetFlightAvailabilityTokenFlightV2 } from "@/types/codegen";

type Props = {
  flights: GetFlightAvailabilityTokenFlightV2[];
  onClick: (direction: "departure" | "return") => void;
};

export const FlightsOverview = ({ flights, onClick }: Props) => {
  const intl = useIntl();

  return (
    <div className="section-card">
      <div className="mb-4 text-lg font-medium text-text-primary">
        {intl.formatMessage(
          {
            defaultMessage:
              "{count, plural, one {Your flight} other {Your flights}}",
            description: "Flights overview card title",
          },
          {
            count: flights.length,
          },
        )}
      </div>

      <ul className="-my-3 divide-y divide-stroke-neutral-soft *:py-3">
        {flights.map((flight, index) => {
          const direction = index === 0 ? "departure" : "return";

          return (
            <li key={index}>
              <FlightButton
                flightDetails={flight}
                segmentDirection={direction}
                onClick={() => {
                  onClick(direction);
                }}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
